import { LOCALSTORAGE_KEY_GUEST_ORDERS } from '@bluheadless/ui-logic/src/constants'
import { useLocalStorage } from '@bluheadless/ui-logic/src/hooks/useLocalStorage'
import { useStore } from '@bluheadless/ui-logic/src/providers/store'
import { useMemo } from 'react'
import GuestOrderForm from '../../../organisms/customer/guest/order-form'
import GuestOrderTable from '../../../organisms/customer/guest/order-table'
import DynamicAreas from '../../../particles/dynamic-areas'

const GuestOrderPageComponent = ({ dynamicAreas }) => {
	const { groupId } = useStore()
	const [storageValue] = useLocalStorage(`${LOCALSTORAGE_KEY_GUEST_ORDERS}_${groupId}`, [])
	const memorizedOrders = useMemo(
		() => storageValue,
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	)

	return (
		<>
			<DynamicAreas areas={dynamicAreas} container="top" />
			<GuestOrderForm />
			<DynamicAreas areas={dynamicAreas} container="middle" />
			<GuestOrderTable orders={memorizedOrders} />
			<DynamicAreas areas={dynamicAreas} container="bottom" />
		</>
	)
}

GuestOrderPageComponent.defaultProps = {}
GuestOrderPageComponent.propTypes = {}

export default GuestOrderPageComponent
